<template>
  <div class="WordSection1">
    <p class="MsoNormal">
      <span
        lang="KO"
        style="line-height:107%;
color:#737373;background:white"
        >서비스 약관
      </span>
    </p>

    <p class="MsoNormal">
      <span
        style="line-height:107%;color:#737373;
background:white"
        >2020<span lang="KO">년 </span>10<span lang="KO">월 </span>5<span
          lang="KO"
          >일 개정
        </span></span
      >
    </p>

    <p class="MsoNormal">
      <span
        lang="KO"
        style="line-height:107%;
color:#737373;background:white"
        >제</span
      ><span
        style="
line-height:107%;color:#737373;background:white"
        >1<span lang="KO">조 【목적】</span>&nbsp;</span
      ><span style="line-height:107%;color:#737373"
        ><br />
        <span lang="KO" style="background:white">본 약관은 에이아이링고㈜</span
        ><span style="background:white">
          (<span lang="KO">이하 </span>'<span lang="KO">에이아이링고</span
          >”<span lang="KO">가라 한다</span>)<span lang="KO"
            >에서 제공하는 번역 관련 서비스</span
          >(<span lang="KO">이하</span> '<span lang="KO">서비스</span
          >'<span lang="KO">라 한다</span>)<span lang="KO"
            >를 이용함에 있어 에이아이링고와 이용자의 권리 및 </span
          ><span lang="KO">의무를 규정함을 목적으로 합니다</span
          >.&nbsp;</span
        ><br />
        <br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >2<span lang="KO">조 【용어정의】</span></span
        ><br />
        <span lang="KO" style="background:white">①</span
        ><span style="background:white">
          '<span lang="KO">에이아이링고</span>' :
          <span lang="KO">법률 </span>AI
          <span lang="KO">번역 서비스를 목적으로 하는 </span>AI Software
          <span lang="KO">개발 및 서비스 제공 회사입니다</span>.</span
        ><br />
        <span lang="KO" style="background:white">② </span
        ><span style="background:white"
          >'<span lang="KO">이용자</span>'<span lang="KO">란</span>
          '<span lang="KO">에이아이링고</span>'<span lang="KO"
            >에 접속하여 이 약관에 따라 </span
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >가 제공하는 서비스를 받는 회원 및 비회원을 말합니다</span
          >.&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">③</span
        ><span style="background:white">
          '<span lang="KO">회원</span>'<span lang="KO"
            >이라 함은</span
          >
          '<span lang="KO">에이아이링고</span>'<span lang="KO"
            >에 개인정보를 제공하여 회원등록을 한 자 또는 기업회원으로서</span
          >, '<span lang="KO">에이아이링고</span>'<span lang="KO"
            >의 정보를 지속적으로 제공받으며</span
          >, “<span lang="KO">에이아이링고</span>”<span lang="KO"
            >가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다</span
          >.&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">④</span
        ><span style="background:white">
          '<span lang="KO">비회원</span>'<span lang="KO"
            >이라 함은 회원에 가입하지 않고 </span
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >가 제공하는 정보와 서비스를 이용하는 자를 말합니다</span
          >.&nbsp;<br /> </span
        ><span lang="KO">⑤ </span>“<span lang="KO">기업관리자</span>”<span
          lang="KO"
          >는 기업회원으로 가입한 기업 내의 이용자들을 관리하고 </span
        >“<span lang="KO">에이아이링고</span>”<span lang="KO"
          >와 업무에 관해 협력하는 자를 말합니다</span
        >. <br />
        <br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >3<span lang="KO">조 【약관 등의 명시와 설명 및 개정】</span></span
        ><br />
        <span lang="KO" style="background:white">① </span
        ><span style="background:white"
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >는 본 약관의 내용과 상호 및 대표자 성명</span
          >, <span lang="KO">영업소 소재지 주소</span>,
          <span lang="KO">전화번호</span>, <span lang="KO">전자우편주소</span>,
          <span lang="KO">사업자등록번호</span>,
          <span lang="KO"
            >개인정보관리책임자 등을 이용자가 쉽게 알 수 있도록 에이아이링고의
            서비스화면</span
          >(<span lang="KO">전면</span>)<span lang="KO">에 게시합니다</span>.
          <span lang="KO">다만</span>,
          <span lang="KO"
            >약관의 내용은 이용자가 연결화면을 통하여 볼 수 있도록 할 수
            있습니다</span
          >.&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">② </span
        ><span style="background:white"
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >는 전기통신기본법</span
          >,
          <span lang="KO"
            >전기통신사업법 등의 관계 법령 등 관련법에 위배되지 않는 범위에서 이
            약관을 개정할 수 있습니다</span
          >.&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">③ </span
        ><span style="background:white"
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여
            현행약관과 함께 </span
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >의 초기화면에 그 적용일자</span
          >
          7<span lang="KO">일 이전부터 적용일자 전일까지 공지합니다</span
          >. </span
        ><br />
        <span lang="KO" style="background:white"
          >④ 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는
          전기통신기본법</span
        ><span style="background:white"
          >,
          <span lang="KO"
            >전기통신사업법 및 관계법령 또는 상관례에 따릅니다</span
          >.&nbsp;</span
        ><br />
        <br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >4<span lang="KO">조 【서비스의 제공 및 변경】</span></span
        ><br />
        <span lang="KO" style="background:white">① </span
        ><span style="background:white"
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >는 다음과 같은 업무를 수행합니다</span
          >.&nbsp;</span
        ><br />
        <span style="background:white"
          >1.
          <span lang="KO"
            >법률문서 등 전문 분야에 대한 기초 번역 초안 제시
          </span></span
        ><br />
        <span style="background:white"
          >2.
          <span lang="KO">법률문장 등 전문분야 문장에 대한 번역 초안 제시 </span
          ><br />
          3.
          <span lang="KO"
            >법률분야를 포함한 전문 분야에 대한 번역서비스에 필요한 컨설팅 및
            자문
          </span></span
        ><br />
        <span style="background:white"
          >4.
          <span lang="KO"
            >법률서비스 및 전문서비스 영역에서 요구되는 기타</span
          >
          '<span lang="KO">에이아이링고</span>'<span lang="KO"
            >가 지정하는 업무</span
          >&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">②</span
        ><span style="background:white">
          '<span lang="KO">에이아이링고</span>'<span lang="KO"
            >는 재화</span
          >,
          <span lang="KO"
            >용역 또는 기술적 사양의 변경 등의 경우에는 추후 체결되는 계약에
            의해 제공할 재화 또는 용역의 내용을 변경할 수 있습니다</span
          >.
          <span lang="KO"
            >이 경우에는 변경된 재화 또는 용역의 내용 및 제공일자를 명시하여
            기존의 재화 또는 용역의 내용을 게시한 곳에 즉시 공지합니다</span
          >.&nbsp;</span
        ><br />
        <br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >5<span lang="KO">조 【서비스의 중단】</span></span
        ><br />
        <span lang="KO" style="background:white">①</span
        ><span style="background:white">
          '<span lang="KO">에이아이링고</span>'<span lang="KO"
            >는 컴퓨터 등 정보통신설비의 보수점검</span
          >, <span lang="KO">교체 및 고장</span>,
          <span lang="KO"
            >통신 두절 등의 사유가 발생한 경우에는 서비스의 제공이 일시적으로
            중단될 수 있습니다</span
          >.&nbsp;“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >는 서비스의 중단으로 인해 이용자가 불편을 겪지 않도록
            웹사이트에 사전 공지합니다</span
          >. </span
        ><br />
        <span lang="KO" style="background:white">② 다만</span
        ><span style="background:white"
          >, '<span lang="KO">에이아이링고</span>'<span lang="KO"
            >는 어떠한 경우라도 서비스 중단으로 인하여 이용자 또는 제</span
          >3<span lang="KO"
            >자가 입은 손해에 대하여 어떠한 책임을 지지 않습니다</span
          >. </span
        ><br />
        <br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >6<span lang="KO">조【회원가입】</span>&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">① 이용자는 </span
        ><span
          style="background:
white"
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >가 정한 가입 양식에 따라 회원정보를 기입한 후 본 약관에 동의한다는
            의사표시를 함으로서 회원가입을 신청합니다</span
          >.
          <span lang="KO"
            >기업 고객의 경우 기업관리자의 확인 절차를 거쳐서 회원가입이 완료될
            수 있습니다</span
          >. </span
        ><br />
        <span lang="KO" style="background:white">② </span
        ><span style="background:white"
          >“<span lang="KO">에이아이링고</span>”<span lang="KO">는 전 </span
          ><span lang="KO"
            >항과 같이 회원으로 가입을 신청한 이용자 중 다음 각호에
            해당하지 않는 한 회원으로 등록합니다</span
          >.&nbsp;</span
        ><br />
        <span style="background:white"
          >1. <span lang="KO">타인 명의의 신청</span>&nbsp;</span
        ><br />
        <span style="background:white"
          >2. <span lang="KO">등록 내용에 허위</span>,
          <span lang="KO">기재누락</span>,
          <span lang="KO">오기가 있는 경우</span></span
        ><br />
        <span style="background:white"
          >3. <span lang="KO">기타 회원으로 등록하는 것이</span> '<span
            lang="KO"
            >에이아이링고</span
          >'<span lang="KO"
            >의 기술상 현저히 지장이 있다고 판단되는 경우</span
          ></span
        ><br />
        <span style="background:white"
          >4.
          <span lang="KO">이용 신청 고객의 사유로 이용승낙이 곤란한 경우</span
          >&nbsp;</span
        ><br />
        <span lang="KO" style="background:white"
          >③ 회원가입 계약의 성립 시기는</span
        ><span style="background:white">
          '<span lang="KO">에이아이링고</span>'<span lang="KO"
            >로부터 회원이 확인 메일을 수령한 시점으로 합니다</span
          >.&nbsp;<span lang="KO"
            >회사에 소속된 이용자인 경우는 기업관리자로부터 통보를 받은 시점으로
            합니다</span
          >. </span
        ><br />
        <span lang="KO" style="background:white"
          >④ 회원은 등록사항에 변경이 있는 경우</span
        ><span style="background:white"
          >,
          <span lang="KO">회원의 프로파일 화면에서 직접 수정하도록 합니다</span
          >.
          <span lang="KO"
            >직접 수정이 안 되는 경우에는 전자우편 등 기타 방법으로</span
          >
          '<span lang="KO">에이아이링고</span>'<span lang="KO"
            >에 변경을 요청하여야 합니다</span
          >.&nbsp;“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >는 확인절차를 거쳐 시스템에서 등록사항을 변경할 수 있습니다</span
          >. </span
        ><br />
        <br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >7<span lang="KO">조【회원 탈퇴 및 자격 상실 등】</span>&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">① 회원은</span
        ><span
          style="background:
white"
        >
          '<span lang="KO">에이아이링고</span>'<span lang="KO"
            >에 언제든지 탈퇴를 요청할 수 있으며 </span
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >는 즉시 회원탈퇴를 처리합니다</span
          >.&nbsp;<span lang="KO"></span>,
          <span lang="KO"
            >기업관리자가 요청하는 경우, 즉시 회원탈퇴를 처리합니다</span
          >. </span
        ><br />
        <span lang="KO" style="background:white"
          >② 회원이 다음 각호의 사유에 해당하는 경우</span
        ><span style="background:white"
          >, “<span lang="KO">에이아이링고</span>”<span lang="KO"
            >는 회원자격을 제한 및 정지시킬 수 있습니다</span
          >.&nbsp;</span
        ><br />
        <span style="background:white"
          >1.
          <span lang="KO">가입 신청 시, 허위 내용을 등록한 경우</span
          >&nbsp;</span
        ><br />
        <span style="background:white"
          >2. “<span lang="KO">에이아이링고</span>”<span lang="KO"
            >를 이용하여 구입한 재화 등의 대금</span
          >, <span lang="KO">기타 </span>“<span lang="KO">에이아이링고</span>”
          <span lang="KO"
            >서비스와 관련하여 회원이 부담하는 채무를 기일에 지급하지 않은
            경우</span
          >&nbsp;</span
        ><br />
        <span style="background:white"
          >3. <span lang="KO">타인의</span> '<span lang="KO"
            >에이아이링고</span
          >'
          <span lang="KO"
            >이용을 방해하거나 타인의 정보를 도용하는 등 전자상거래 질서를 교란하는
            경우</span
          ></span
        ><br />
        <span style="background:white"
          >4. “<span lang="KO">에이아이링고</span>”<span lang="KO"
            >를 이용하여 법령 또는 본 약관이 금지하거나 공서양속에 반하는 행위를
            하는 경우</span
          >&nbsp;</span
        ></span
      >
    </p>

    <p class="MsoNormal">
      <span
        style="line-height:107%;color:#737373;
background:white"
        >5. “<span lang="KO">에이아이링고</span>”<span lang="KO"
          >의 기술을 도용</span
        >,
        <span lang="KO"
          >해킹하거나 역엔지니어링 또는 디어셈블링 등의 행위를 하는 경우
        </span></span
      ><span style="line-height:107%;color:#737373"
        ><br />
        <br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >8<span lang="KO">조【회원에 대한 통지】</span>&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">① </span
        ><span style="background:white"
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >가 회원에 대한 통지를 하는 경우</span
          >, <span lang="KO">회원이</span> '<span lang="KO"
            >에이아이링고</span
          >'<span lang="KO"
            >와 미리 약정하여 지정한 전자우편 주소 또는 휴대전화로 할 수
            있습니다</span
          >.&nbsp;<span lang="KO"
            >기업의 경우에는 기업관리자에게 통지할 수 있습니다</span
          >. </span
        ><br />
        <span lang="KO" style="background:white">② </span
        ><span style="background:white"
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >는 불특정다수 회원에 대한 통지의 경우, </span
          >
          1<span lang="KO">주일이상</span> '<span lang="KO"
            >에이아이링고</span
          >'
          <span lang="KO"
            >게시판에 게시함으로서 개별 통지에 갈음할 수 있습니다</span
          >. <span lang="KO">다만</span>,
          <span lang="KO"
            >회원 본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는
            개별통지를 합니다</span
          >.&nbsp;</span
        ><br />
        <br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >9<span lang="KO">조【서비스 신청】</span></span
        ><br />
        <span style="background:white"
          >“<span lang="KO">에이아이링고</span>”
          <span lang="KO">이용자는</span> '<span lang="KO"
            >에이아이링고</span
          >'
          <span lang="KO">웹사이트에서 서비스를 신청할 수 있으며</span>,
          <span lang="KO"
            >기업인 경우에는 기업관리자를 통해 확인절차를 거친 후에 서비스를
            신청할 수 있습니다</span
          >.
        </span></span
      >
    </p>

    <p class="MsoNormal">
      <span style="line-height:107%;color:#737373"
        ><br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >10<span lang="KO">조【서비스 이용】</span></span
        ><br />
        <span lang="KO" style="background:white">① 신청한 서비스에 대하여 </span
        ><span style="background:white"
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >로부터 수신확인 메일을 받은 시점부터 서비스 이용이 성립된 것으로
            간주합니다</span
          >. <span lang="KO">다만</span>, “<span lang="KO">에이아이링고</span
          >”<span lang="KO">는 제</span>9<span lang="KO"
            >조와 같은 서비스 신청에 대하여 다음 각호에 해당하는 경우, 승낙하지 않을
            수 있습니다</span
          >.&nbsp;</span
        ><br />
        <span style="background:white"
          >1. <span lang="KO">신청 내용에 허위</span>,
          <span lang="KO">기재누락</span>,
          <span lang="KO">오기가 있는 경우</span>&nbsp;</span
        ><br />
        <span style="background:white"
          >2.
          <span lang="KO">기타 서비스 신청에 승낙 시, </span>
          <span lang="KO"
            >기술상 또는 기타 사유로 </span>'<span
            lang="KO"
          >에이아이링고</span
          >'<span lang="KO">에 현저히 지장이 있다고 판단하는 경우</span
          >&nbsp;</span
        ></span
      >
    </p>

    <p class="MsoNormal">
      <span
        lang="KO"
        style="line-height:107%;
color:#737373;background:white"
        >② </span
      ><span
        style="
line-height:107%;color:#737373;background:white"
        >AI<span lang="KO">로 번역된 문장을 수정하는 경우</span>,
        <span lang="KO">이용자는</span> AI
        <span lang="KO"
          >번역 모델을 개선할 수 있도록 수정된 번역문을 입력하거나
          "에이아이링고"에 통지하도록 합니다</span
        >. </span
      ><span
        style="line-height:
107%;color:#737373"
        ><br />
        <br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >11<span lang="KO">조【지급방법】</span></span
        ><br />
        <span style="background:white"
          >'<span lang="KO">에이아이링고</span>'<span lang="KO"
            >에서 구매한 컨텐츠 또는 용역에 대한 대금지급방법은 이용자 또는
            기업과 </span
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >가 합의한 바에 따라 지급할 수 있습니다</span
          >. <span lang="KO">다만</span>,
          <span lang="KO"
            >개별 이용자인 경우 다음 방법으로 대금을 지불할 수 있습니다</span
          >. </span
        ><br />
        <span style="background:white"
          >1. <span lang="KO">계좌이체</span>&nbsp;</span
        ><br />
        <span style="background:white"
          >2. <span lang="KO">신용카드 등의 각종 카드 결제</span>&nbsp;</span
        ><br />
        <span style="background:white"
          >3. <span lang="KO">온라인무통장입금</span>&nbsp;</span
        ><br />
        <span style="background:white"
          >4.
          <span lang="KO"
            >기타 이용가능한 전자적 지급 방법에 의한 대금 지급 등</span
          >&nbsp;</span
        ><br />
        <br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >12<span lang="KO">조【수신확인통지</span>/<span lang="KO"
            >구매신청 변경 및 취소】</span
          >&nbsp;</span
        ><br />
        <span lang="KO" style="background:white"
          >① 이용자에게 적법하게 부여된 이용자 계정을 통하여 이용자가 </span
        ><span style="background:white"
          >AI
          <span lang="KO"
            >번역 파일을 업로드함으로써 서비스 이용 신청이 있는 것으로
            간주합니다</span
          >. </span
        ><br />
        <span lang="KO" style="background:white">② 에이아이링고는 이용자</span
        ><span style="background:white"
          >(<span lang="KO">회사 포함</span>)<span lang="KO"
            >에게 주기적으로 서비스 요청 및 처리에 대해서 요약하여 이메일로 보고합니다</span
          >.
        </span></span
      >
    </p>

    <p class="MsoNormal">
      <span style="line-height:107%;color:#737373"
        ><br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >13<span lang="KO">조【환급】</span></span
        ><br />
        <span lang="KO" style="background:white"
          >① 이용자가 서비스를 제공받은 후 다음 각 호의 사유로 인하여 요금 환불을
          요청한 경우에 "에이아이링고"는 이용고객이 결제한 요금을 환불합니다</span
        ><span style="background:white"
          >.&nbsp;<span lang="KO"
            >번역 품질을 포함한 기타 사유로 인한 환불은 인정되지 않습니다</span
          >. </span
        ><br />
        <span style="background:white"
          >1.
          <span lang="KO"
            >번역 서비스에 기술적인 문제가 발생하여 이용고객이 정상적으로 번역된
            파일을 받지 못한 경우</span
          ></span
        ><br />
        <span style="background:white"
          >2.
          <span lang="KO"
            >이용고객의 환불요청이 상거래의 관례에 비추어 "에이아이링고"에서 정당하다고
            판단되는 경우</span
          >&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">② 전</span
        ><span style="background:white">
          <span lang="KO"
            >항의 환불 조건에도 불구하고 아래 각 호의 해당이 되는 경우 회사는
            환불을 아니할 수 있습니다</span
          >.&nbsp;</span
        ><br />
        <span style="background:white"
          >1. <span lang="KO">이용자가 요금을 결제한 후,</span> 10<span
            lang="KO"
            >일이 경과한 경우</span
          >&nbsp;</span
        ><br />
        <span style="background:white"
          >2.
          <span lang="KO"
            >이용자의 컴퓨터 및 사무환경 문제로 서비스를 이용하지 못한
            경우</span
          >&nbsp;</span
        ><br />
        <span style="background:white"
          >3.
          <span lang="KO"
            >이용자가 요금결제 후 특별한 사유 없이 환불을 요청하는 경우</span
          >&nbsp;<br />
          4.
          <span lang="KO"
            >이용자가 번역 품질의 사유로 환불을 요청하는 경우
          </span></span
        ><br />
        <span lang="KO" style="background:white"
          >③ 이용고객은 온라인 또는 유선으로 환불을 신청할 수 있으며 "에이아이링고"는
          결제 취소 또는 무통장입금으로 환불합니다</span
        ><span style="background:white">.&nbsp;</span><br />
        <br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >14<span lang="KO">조【개인정보보호】</span>&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">① </span
        ><span style="background:white"
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >는 이용자의 정보수집 시, 구매계약 이행에 필요한 최소한의 정보를
            수집합니다</span
          >.
          <span lang="KO"
            >다은 필수 사항이며 그 외 사항은 선택사항입니다</span
          >.&nbsp;</span
        ><br />
        <span style="background:white"
          >1. <span lang="KO">성명</span>&nbsp;</span
        ><br />
        <span style="background:white"
          >2. <span lang="KO">전화번호</span>&nbsp;</span
        ><br />
        <span style="background:white"
          >3. <span lang="KO">희망</span>ID(<span lang="KO">회원의 경우</span
          >)&nbsp;</span
        ><br />
        <span style="background:white"
          >4. <span lang="KO">전자우편 주소</span>&nbsp;</span
        ><br />
        <span lang="KO" style="background:white"
          >② 이용자가 회사인 경우 회사에 관련된 정보 </span
        ><span style="background:white"
          >(<span lang="KO">회사명</span>, <span lang="KO">주소</span>,
          <span lang="KO">전화번호 등</span>)<span lang="KO"
            >을 추가로 수집할 수 있습니다</span
          >. </span
        ><br />
        <span lang="KO" style="background:white"
          >③ 제공된 개인정보는 당해 이용자의 동의 없이 목적 외로 이용하거나
          제</span
        ><span style="background:white"
          >3<span lang="KO">자에게 제공할 수 없으며</span>,
          <span lang="KO">이에 대한 책임은 "에이아이링고"가 집니다</span>.
          <span lang="KO">다만</span>,
          <span lang="KO">다음의 경우에는 예외로 합니다</span>.&nbsp;</span
        ><br />
        <span style="background:white"
          >1. <span lang="KO">이용자가 동의한 경우</span><br />
          2.
          <span lang="KO"
            >배송업무상, 배송업체에게 배송에 필요한 최소한의 이용자의 정보</span
          >(<span lang="KO">성명</span>, <span lang="KO">주소</span>,
          <span lang="KO">전화번호</span>)<span lang="KO">를 알려주는 경우</span
          >&nbsp;</span
        ><br />
        <span style="background:white"
          >3. <span lang="KO">통계작성</span>,
          <span lang="KO"
            >학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 식별할
            수 없는 형태로 제공하는 경우</span
          >&nbsp;</span
        ><br />
        <span style="background:white"
          >4.
          <span lang="KO">거래에 따른 대금 정산을 위하여 필요한 경우</span
          >&nbsp;</span
        ><br />
        <span style="background:white"
          >5.
          <span lang="KO">도용방지를 위하여 본인 확인에 필요한 경우</span
          >&nbsp;</span
        ><br />
        <span style="background:white"
          >6.
          <span lang="KO"
            >법률의 규정 또는 법률에 의거하여 필요한 불가피한 사유가 있는
            경우</span
          >&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">④ 이용자는 언제든지 </span
        ><span style="background:white"
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >가 보유하고 있는 본인의 개인정보에 대해 열람 및 정정을 요구할 수
            있으며 </span
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >는 이에 대해 지체 없이 필요한 조치를 취할 의무를 부담합니다</span
          >. </span
        ><br />
        <span lang="KO" style="background:white">⑥ </span
        ><span style="background:white"
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >는 개인정보 보호를 위하여 관리 인원을 최소화합니다.
            최소화합니다</span
          >.
        </span></span
      >
    </p>

    <p class="MsoNormal">
      <span
        lang="KO"
        style="line-height:107%;
color:#737373;background:white"
        >⑤ </span
      ><span
        style="
line-height:107%;color:#737373;background:white"
        >'<span lang="KO">에이아이링고</span>'<span lang="KO"
          >는 개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는 당해
          개인정보를 지체 없이 파기합니다</span
        >.&nbsp;</span
      ><span style="line-height:107%;color:#737373"
        ><br />
        <br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >15<span lang="KO">조【</span>'<span lang="KO">에이아이링고</span
          >'<span lang="KO">의 의무】</span>&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">① </span
        ><span style="background:white"
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >는 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며
            본 약관이 정하는 바에 따라 지속적이고</span
          >, <span lang="KO">안정적으로 재화 및</span><span lang="KO"
            >용역을 제공하는데 최선을 다하여야 합니다</span
          >.&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">② </span
        ><span style="background:white"
          >“<span lang="KO">에이아이링고</span>”<span lang="KO"
            >는 이용자가 안전하게 서비스를 이용할 수 있도록 이용자의
            개인정보</span
          >(<span lang="KO">신용정보 포함</span>)<span lang="KO"
            >보호를 위한 보안 시스템을 갖추어야 합니다</span
          >.&nbsp;</span
        ><br />
        <br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >16<span lang="KO">조【회원의</span> ID
          <span lang="KO">및 비밀번호에 대한 의무】</span>&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">① 제</span
        ><span style="background:white"
          >17<span lang="KO">조의 경우를 제외한</span> ID<span lang="KO"
            >와 비밀번호에 대한 관리책임은 회원에게 있습니다</span
          >.&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">② 회원은 자신의</span
        ><span
          style="background:
white"
        >
          ID <span lang="KO">및 비밀번호를 제</span>3<span lang="KO"
            >자에게 이용하게 해서는 안 됩니다</span
          >.&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">③ 회원이 자신의</span
        ><span
          style="background:
white"
        >
          ID <span lang="KO">및 비밀번호를 도난 당하거나 제</span>3<span
            lang="KO"
            >자가 사용하고 있음을 인지한 경우에는 바로</span
          >
          '<span lang="KO">에이아이링고</span>'<span lang="KO"
            >에 통보하고</span
          >
          '<span lang="KO">에이아이링고</span>'<span lang="KO"
            >의 안내가 있는 경우에는 그에 따라야 합니다</span
          >.&nbsp;</span
        ><br />
        <br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >17<span lang="KO">조【이용자의 의무】</span>&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">① 이용자는 에이아이링고의</span
        ><span style="background:white">
          AI <span lang="KO">번역 결과물은 번역 초안이므로 검토</span>,
          <span lang="KO">수정</span>,
          <span lang="KO">검증할 책임이 있습니다</span>.
        </span></span
      >
    </p>

    <p class="MsoNormal">
      <span
        lang="KO"
        style="line-height:107%;
color:#737373;background:white"
        >② 이용자는 번역의 품질을 향상시키기 위해서 이용자가 검토한 문안이
        반영될 수 있도록 해야 함을 인식하고 있으며</span
      ><span
        style="line-height:107%;color:#737373;
background:white"
        >,
        <span lang="KO"
          >번역의 품질을 행상시키기 위해서 번역 모델을 주기적으로
          개선해야 함을 인지 하고 있습니다</span
        >.
      </span>
    </p>

    <p class="MsoNormal">
      <span
        lang="KO"
        style="line-height:107%;
color:#737373;background:white"
        >③ 이용자는 다음 행위를 하여서는 안 됩니다</span
      ><span style="line-height:107%;color:#737373;background:white"
        >.&nbsp;</span
      ><span style="line-height:107%;color:#737373"
        ><br />
        <span style="background:white"
          >1.
          <span lang="KO">신청 또는 변경 시, 허위 내용의 등록</span>&nbsp;</span
        ><br />
        <span style="background:white"
          >2. <span lang="KO">타인의 정보 도용</span>&nbsp;</span
        ><br />
        <span style="background:white"
          >3. '<span lang="KO">에이아이링고</span>'<span lang="KO"
            >에 게시된 정보의 변경</span
          >&nbsp;</span
        ><br />
        <span style="background:white"
          >4. “<span lang="KO">에이아이링고</span>”<span lang="KO"
            >가 지정한 정보 이외의 정보</span
          >(<span lang="KO">컴퓨터 프로그램 등</span>)
          <span lang="KO">등의 송신 또는 게시</span>&nbsp;</span
        ><br />
        <span style="background:white"
          >5. '<span lang="KO">에이아이링고</span>'
          <span lang="KO">및 기타 제</span>3<span lang="KO"
            >자의 저작권 등 지적재산권에 대한 침해</span
          >&nbsp;</span
        ><br />
        <span style="background:white"
          >6. '<span lang="KO">에이아이링고</span>'
          <span lang="KO">및 기타 제</span>3<span lang="KO"
            >자의 명예를 손상시키거나 업무를 방해하는 행위</span
          >&nbsp;</span
        ><br />
        <span style="background:white"
          >7. <span lang="KO">외설적이거나 폭력적인 메시지</span>,
          <span lang="KO">화상</span>, <span lang="KO">음성</span>,
          <span lang="KO"
            >기타 동서양속에 반하는 정보를 에이아이링고에 공개 또는 게시하는
            행위</span
          ></span
        ><br />
        <br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >18<span lang="KO">조【지적재산권】</span>&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">① </span
        ><span style="background:white"
          >'<span lang="KO">에이아이링고</span>'<span lang="KO"
            >가 작성한 저작물 </span
          >(<span lang="KO">소프트웨어 및 모델</span>)<span lang="KO"
            >에 대한 저작권 기타 지적재산권은</span
          >
          '<span lang="KO">에이아이링고</span>'<span lang="KO"
            >에 귀속됩니다</span
          >.
          <span lang="KO"
            >이용자는 에이아이링고의 사전 허가 없이 에이아이링고의 저작물을
            직</span
          >, <span lang="KO">간접적으로 변조</span>,
          <span lang="KO">복사</span>, <span lang="KO">배포</span>,
          <span lang="KO">출판</span>, <span lang="KO">전시</span>,
          <span lang="KO">판매 하거나 상품제작</span>,
          <span lang="KO">인터넷</span>,
          <span lang="KO"
            >모바일 및 데이터베이스를 비롯한 각종 정보서비스 등에 사용하는 것을
            금합니다</span
          >.&nbsp;<span lang="KO">또한</span>,
          <span lang="KO"
            >이용자는 에이아이링고의 저작물 및 지적재산권을 침해</span
          >, <span lang="KO">도용</span>, <span lang="KO">해킹</span>,
          <span lang="KO">디어셈블링</span>,
          <span lang="KO">역엔지니어링을 하지 않습니다</span>. </span
        ><br />
        <span lang="KO" style="background:white"
          >② 이용자는 에이아이링고의 저작물을 본 계약의 내용과 에이아이링고의
          소프트웨어 정책에 따라 사용할 수 있는 권한이 있습니다</span
        ><span style="background:white">. </span><br />
        <br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >19<span lang="KO">조【서비스 면책사항】</span>&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">① 천재지변</span
        ><span
          style="background:
white"
          >, <span lang="KO">전쟁</span>, <span lang="KO">화재</span>,
          <span lang="KO">홍수</span>, <span lang="KO">폭풍</span>,
          <span lang="KO">파업</span>, <span lang="KO">노동분쟁</span>,
          <span lang="KO">폭동</span>, <span lang="KO">테러</span>,
          <span lang="KO"
            >전기 등 공익서비스의 중단 및 기타 이에 준하는 불가항력으로 인하여
            '에이아이링고'의 서비스가 제공될 수 없는 경우에는 서비스 제공에 대한
            책임이 면제됩니다</span
          >.&nbsp;</span
        ><br />
        <span lang="KO" style="background:white"
          >② '에이아이링고'는 이용자의 귀책사유로 인한 서비스 이용의 장애 또는
          손해에 대하여 면책됩니다</span
        ><span style="background:white">.&nbsp;</span><br />
        <span lang="KO" style="background:white"
          >③ '에이아이링고'는 서비스용 설비의 보수</span
        ><span style="background:white"
          >, <span lang="KO">교체</span>, <span lang="KO">정기점검</span>,
          <span lang="KO"
            >공사 등 부득이한 사유로 발생한 손해에 대하여 면제됩니다</span
          >.&nbsp;</span
        ><br />
        <span lang="KO" style="background:white"
          >④ 이용자는 '에이아이링고' 서비스로 완벽한 번역물이 제공되지
          않음을 인지하고 있으며</span
        ><span style="background:white"
          >, <span lang="KO">번역물 사용 이전의 검토</span>,
          <span lang="KO">수정 및 검증에 대한 책임은 이용자에게 있습니다</span>.
          <br />
          <br /> </span
      ></span>
    </p>

    <p class="MsoNormal">
      <span
        lang="KO"
        style="line-height:107%;
color:#737373;background:white"
        >제</span
      ><span
        style="
line-height:107%;color:#737373;background:white"
        >20<span lang="KO">조 【재판권 및 준거법】</span>&nbsp;</span
      ><span style="line-height:107%;color:#737373"
        ><br />
        <span lang="KO" style="background:white">①</span
        ><span style="background:white">
          '<span lang="KO">에이아이링고</span>'<span lang="KO"
            >과 이용자 간에 발생한 분쟁에 관한 소송의 관할 법원은 서울중앙지방법원으로
            합니다</span
          >. </span
        ><br />
        <span lang="KO" style="background:white">②</span
        ><span style="background:white">
          '<span lang="KO">에이아이링고</span>'<span lang="KO"
            >과 이용자 간에 제기된 소송에는 한국법을 적용합니다</span
          >.&nbsp;</span
        ><br />
        <br />
        <span lang="KO" style="background:white">제</span
        ><span style="background:white"
          >21<span lang="KO">조【기타 조항】</span>&nbsp;</span
        ><br />
        <span lang="KO" style="background:white"
          >약관을 위반하거나 서비스 이용에</span
        ><span style="background:white"
          > <span lang="KO">불편사항이 있을 경우</span>,
          <span lang="KO">고객지원센터로 문의하시기 바랍니다</span>.&nbsp;</span
        ><br />
        <span lang="KO" style="background:white">☏ 문의처</span
        ><span
          style="background:
white"
          >:
        </span></span
      ><a href="mailto:support@ailinggo.ai"
        ><span style="line-height:107%;background:white"
          >support@ailinggo.ai</span
        ></a
      ><span style="line-height:107%;color:#737373;background:white"> </span
      ><span style="line-height:107%;color:#737373"
        ><br />
        <br />
        <span lang="KO" style="background:white">부칙</span
        ><span style="background:white">: <span lang="KO">시행일</span></span
        ><br />
        <span lang="KO" style="background:white">이 약관은</span
        ><span
          style="background:
white"
        >
          2020<span lang="KO">년 </span>10<span lang="KO">월 </span>05<span
            lang="KO"
            >일부터 시행합니다</span
          >.(ver. 1.0)
        </span></span
      >
    </p>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.wrapper {
  white-space: pre-line;
}
</style>
